<p class="card-text">Build responsive and user-friendly web interfaces using modern frameworks.</p>
<ul>
    <li>Experience with React or Angular</li>
    <li>Proficient in HTML, CSS, JavaScript</li>
</ul>
